<template>
  <svg class="point-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="10" fill="#FF7A00" />
    <path
      d="M7.36816 15.788V5.26172H10.7338C12.9914 5.26172 14.7366 6.07253 14.7366 8.57609C14.7366 10.9801 12.9914 12.0469 10.7892 12.0469H9.41803V15.788H7.36816ZM9.41803 10.3826H10.6507C12.0635 10.3826 12.7421 9.77096 12.7421 8.57609C12.7421 7.33853 11.9942 6.94024 10.5815 6.94024H9.41803V10.3826Z"
      fill="#FAFAFA"
    />
  </svg>
</template>
